module.exports = __webpack_public_path__ + "static/media/mrh-policy-number.5e5bbd4b.png";